import { type GridColumnVisibilityModel } from '@mui/x-data-grid';

export const DISPLAY_MODES = ['promo', 'voucher', 'channel-markup', 'all'] as const;

export type DisplayMode = (typeof DISPLAY_MODES)[number];

function isDisplayMode(value: string | null | undefined): value is DisplayMode {
  return typeof value === 'string' && DISPLAY_MODES.some((mode) => mode === value);
}

export function parseDisplayMode(value: string | null | undefined): DisplayMode {
  return isDisplayMode(value) ? value : 'all';
}

/**
 * Focused pages retain the contextual columns and hide the two unrelated
 * identifier groups. Users can still opt back in through the column selector.
 */
export function getDisplayColumnVisibility(
  displayMode: DisplayMode,
  fields: { promo?: string; voucher?: Array<string>; channelMarkup?: Array<string> },
): GridColumnVisibilityModel {
  switch (displayMode) {
    case 'promo':
      return Object.fromEntries(
        [...(fields.voucher ?? []), ...(fields.channelMarkup ?? [])].map((field) => [field, false]),
      );
    case 'voucher':
      return Object.fromEntries(
        [fields.promo, ...(fields.channelMarkup ?? [])].filter(Boolean).map((field) => [field, false]),
      );
    case 'channel-markup':
      return Object.fromEntries(
        [fields.promo, ...(fields.voucher ?? [])].filter(Boolean).map((field) => [field, false]),
      );
    case 'all':
      return {};
  }
}
